<template>
  <div class='h-dialogContainer'>
    <template>
      <BaseBusiness :formParams='formParamsBase' :reMountPage='reMount' ref="base" :opCode="opCode"></BaseBusiness>
    </template>
    <SubTabs :elements="tabs.elements" :styles='tabs.styles'>
      <template v-slot:tabsContent>
        <div style="margin-top: 15px;">
          <VoiceBusiness :formParams='formParamsVoice' :reMountPage='reMount' ref="voice" :opCode="opCode"></VoiceBusiness>
        </div>
        <div style="margin-top: 15px;">
          <DataBusiness :formParams='formParamsData' :reMountPage='reMount' ref="data" :opCode="opCode"></DataBusiness>
        </div>
        <div style="margin-top: 15px;">
          <VideoBusiness :formParams='formParamsVideo' :reMountPage='reMount' ref="video" :opCode="opCode"></VideoBusiness>
        </div>
      </template>
    </SubTabs>
  </div>
</template>

<script>
import BaseBusiness from '../U_BaseBusiness';
import VoiceBusiness from '../U_VoiceBusiness';
import DataBusiness from '../U_DataBusiness';
import VideoBusiness from '../U_VideoBussiness';
import SubTabs from '../../../util/SubTabs';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import commonJs from '../../common';

export default {
  name: 'AddGroupDialog',
  components: {
    SubTabs,
    BaseBusiness,
    VoiceBusiness,
    DataBusiness,
    VideoBusiness,
  },
  mixins: [commonJs],
  props: [
    'opCode',
    'neid'
  ],
  methods: {
    mainHandler(data = []) {
      const $this = this;
      let arrBase = null;
      let arrVioce = null;
      let arrData = null;
      let arrVideo = null;
      const params = {
        msgid: this.msg.addGroup,
        neid: this.neid
      };
      this.$axios.post('/lte/ems/subscriber/mcs/getParamJson', params)
        .then((response) => {
          const res = response.data.resultVal;
          const sub = new SubscriberTool();
          this.initAnotherBusiness(res, data);
          const resultMap = sub.$devideByGroupBy(res, data);
          // this.initAnotherBusinessDatas(data);
          arrBase = resultMap.get($this.formParamsBase.modelName);
          $this.formParamsBase = arrBase;

          arrVioce = resultMap.get($this.formParamsVoice.modelName);
          $this.formParamsVoice = arrVioce;

          arrData = resultMap.get($this.formParamsData.modelName);
          $this.formParamsData = arrData;

          arrVideo = resultMap.get($this.formParamsVideo.modelName);
          $this.formParamsVideo = arrVideo;

        });
    },
    getDatas() {
      const validateReturn = this.$refs.base.validateResult() === false
        ? false : (this.$refs.voice.validateResult() === false
          ? false : (this.$refs.data.validateResult() === false
            ? false : (this.$refs.video.validateResult() === false
              ? false : true)));
      if (this.getDatasAnotherControl() === false) {
        return false;
      }
      if (!validateReturn) {
        console.log('表单验证不通过');
        return false;
      }
      const map = this.$refs.base.getDatas();
      const mapVoice = this.$refs.voice.getDatas();
      const mapData = this.$refs.data.getDatas();
      const mapVideo = this.$refs.video.getDatas();
      const returnObj = {};
      Array.from(map).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapVoice).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapData).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapVideo).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      return returnObj;
    },
    getDatasAnotherControl() {
      const baseDatas = this.$refs.base.getDatas();
      if (baseDatas.get('grouptype') === 2 && baseDatas.get('areaFlag') === 0) {
        this.$toast('warning', this.$t('MCS.nozonegrp'))
        return false;
      }
    },
    initAnotherBusiness(res, data) {
      switch (this.opCode) {
        case '-1':
          this.initCommonBusiness(res);
          break;
        case '0':
          this.initCommonBusiness(res);
          break;
        case '1':
          // 动态组不可修改
          if (data.grouptype === 1) {
            res.forEach((item) => {
              item.readonly = true;
            });
          } else {
            this.initCommonBusiness(res);
          }
          break;
        case '2':
          this.initCommonBusiness(res);
          break;
        default:
      }
    },
    initCommonBusiness(res) {
      res.forEach((item) => {
        switch (item.name) {
          case 'grouptype':
            if (item.options !== undefined || item.options.length !== 0) {
              for (let i = 0; i < item.options.length; i++) {
                if (item.options[i].value === 1) { // 动态组
                  item.options.splice(i, 1);
                  break;
                }
              }
            }
            break;
          default:
        }
      });
    },

    reMount() {
      this.$refs.base.reMount();
      this.$refs.voice.reMount();
      this.$refs.data.reMount();
      this.$refs.video.reMount();
    },
  },
  data() {
    return {
      grouptype: 1,
      tabs: {
        elements: {
          refName: 'xxxxx',
          items: [
            { header: this.$t('MCS.voiceBusiness'), contentKey: 'item1-content' },
            { header: this.$t('MCS.dataBusiness'), contentKey: 'item2-content' },
            { header: this.$t('MCS.videoBusiness'), contentKey: 'item3-content' },
          ]
        },
        styles: {
          heightMode: 'Auto'
        }
      },
      formParamsBase: {
        json: '',
        formId: this.opCode + 'baseBusinessGms',
        subObject: '',
        modelName: 'base',
      },
      formParamsVoice: {
        json: '',
        formId: this.opCode + 'voiceBusinessGms',
        subObject: '',
        modelName: 'voice',
      },
      formParamsData: {
        json: '',
        formId: this.opCode + 'dataBusinessGms',
        subObject: '',
        modelName: 'data',
      },
      formParamsVideo: {
        json: '',
        formId: this.opCode + 'videoBusinessGms',
        subObject: '',
        modelName: 'video',
      },
    };
  },
};
</script>
